export const WORKSHEET_CURRENCY_SYMBOL = '$';
